import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADLocalUser entity - alias of ADObject
 * Represents Active Directory local user objects
 */
export const adLocalUserEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADLocalUser', display: 'AD Local User' },
  alias: 'ADObject',
};
